export const MENU_BUILDER_ACTION = 'MENU_BUILDER_ACTION';
export const CONTAINER_ACTION = 'CONTAINER_ACTION';
export const WIDGET_ACTION = 'WIDGET_ACTION';
